(() => {
  if (window.hcDemoCardLoaded) return;

  const getVideo = (modal) => modal && modal.querySelector('video');

  const resetTranscript = (modal) => {
    const transcript = modal && modal.querySelector('[data-hc-demo-transcript]');
    const content = modal && modal.querySelector('[data-hc-demo-transcript-content]');

    if (transcript) {
      transcript.open = false;
    }

    if (content) {
      content.scrollTop = 0;
    }
  };

  const resetVideo = (modal) => {
    const video = getVideo(modal);

    if (!video) return;

    video.pause();
    video.currentTime = 0;
  };

  const closeModal = (modal) => {
    if (!modal) return;

    resetVideo(modal);
    resetTranscript(modal);

    const trigger = modal._hcDemoTrigger;

    if (trigger instanceof Element) {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus();
    }

    delete modal._hcDemoTrigger;

    if (typeof modal.close === 'function' && modal.open) {
      modal.close();
    } else {
      modal.removeAttribute('open');
    }
  };

  const openModal = (modal, trigger) => {
    if (!modal) return;

    modal._hcDemoTrigger = trigger;
    trigger.setAttribute('aria-expanded', 'true');

    if (typeof modal.showModal === 'function') {
      if (!modal.open) {
        try {
          modal.showModal();
        } catch (error) {
          modal.setAttribute('open', '');
        }
      }
    } else {
      modal.setAttribute('open', '');
    }

    const video = getVideo(modal);

    if (!video) return;

    video.currentTime = 0;

    const playPromise = video.play();

    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {});
    }
  };

  document.addEventListener('click', (event) => {
    const target = event.target;

    if (!(target instanceof Element)) return;

    const openButton = target.closest('[data-hc-demo-open]');
    const closeButton = target.closest('[data-hc-demo-close]');

    if (openButton) {
      const card = openButton.closest('[data-hc-demo-card]');
      const modal = card && card.querySelector('[data-hc-demo-modal]');

      openModal(modal, openButton);
      return;
    }

    if (closeButton) {
      closeModal(closeButton.closest('[data-hc-demo-modal]'));
      return;
    }

    if (target.matches('[data-hc-demo-modal][open]')) {
      closeModal(target);
    }
  });

  document.addEventListener(
    'close',
    (event) => {
      const modal = event.target;

      if (modal instanceof Element && modal.matches('[data-hc-demo-modal]')) {
        resetVideo(modal);
        resetTranscript(modal);

        const trigger = modal._hcDemoTrigger;

        if (trigger instanceof Element) {
          trigger.setAttribute('aria-expanded', 'false');
          trigger.focus();
        }

        delete modal._hcDemoTrigger;
      }
    },
    true
  );

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('[data-hc-demo-modal][open]').forEach(closeModal);
  });

  window.hcDemoCardLoaded = true;
})();
